module.exports = __webpack_public_path__ + "static/media/Buy_Now_Button@3x.7d5601bc.png";